import { useCloseUnlessOrgNetwork } from '../hooks/useCloseWhenMissing'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import useMergedData from '../hooks/useMergedData'
import type { FileTarget } from '../lib/webdavClient'
import FileBrowser from './FileBrowser'

// A network's shared drive — every node in the network sees these files.
//
// ⚠ Addressed by network ID, not name. The old `/dav/<network-name>/` resolved
// the name SERVER-SIDE, and a name does not identify a network: the same name
// can sit in several of a member's orgs, and the router picked "personal org
// wins, then oldest". Two people could open one URL and get different networks.
export default function NetworkFiles() {
  const { networkId = '' } = useParams<{ networkId: string }>()
  // ⚠ An id in the path that is not an object of the active org sends the reader home (app#475).
  useCloseUnlessOrgNetwork(networkId)
  const { networks } = useMergedData()
  const network = networks.find(n => n.id === networkId)

  const target = useMemo<FileTarget>(() => ({ tree: 'networks', id: networkId }), [networkId])

  return (
    <FileBrowser
      target={target}
      found={!!network}
      basePath={`/networks/${networkId}/files`}
      defaultBackTo={`/networks/${networkId}`}
      defaultBackLabel={network?.name ?? 'Network'}
      notFoundBackTo="/networks"
      notFoundMessage="Network not found."
    />
  )
}
